<router-outlet />

<!-- Mounted once so any feature can raise a toast through ToastService. -->
<ui-toast-container />

<!-- Mounted once so any feature can ask a yes/no question through ConfirmService. -->
<ui-confirm-dialog />
